module.exports = __webpack_public_path__ + "img/avantage-livraison.5bc2e93c.svg";